import { useAjax, useMzMutation, useTranslation } from "@bsm/component";

export const useAddStudentMutation = () => {
    const t = useTranslation();
    const ajax = useAjax();
    return useMzMutation(
        (payload: Record<string, any>) => {
            return ajax.send({
                type: "POST",
                content_type: "application/json",
                url: "student/scholarity/add-students",
                data: payload,
            });
        },
        {
            error_message: false,
            success_message: "Student(s) successfully added"
        }
    );
}